module.exports = __webpack_public_path__ + "img/footer_des.2a7d315f.png";